var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPoliceman = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 398.582 511.999"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-56.708)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 318",
  d: "M310.035 270.228a15 15 0 00-16.129 2.528c-13.2 11.838-20.219 18.358-37.907 18.358s-24.7-6.52-37.906-18.359a15 15 0 00-25.013 11.169l-10 56.8c0 4.525 2.042 19.32 5.558 22.168l57.92 46.92a15 15 0 0018.884 0l57.92-46.92c3.516-2.848 5.558-17.643 5.558-22.168l-10-56.8a15 15 0 00-8.883-13.7z",
  fill: "#ffc4a4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 319",
  d: "M310.035 270.228a15 15 0 00-16.129 2.528c-13.2 11.838-20.219 18.358-37.907 18.358v122.042a14.977 14.977 0 009.442-3.344l57.92-46.92c3.516-2.848 5.558-17.643 5.558-22.168l-10-56.8a15 15 0 00-8.883-13.7z",
  fill: "#ffab82"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 320",
  d: "M370.992 67.5a40.911 40.911 0 00-21.555-25.6C344 38.644 304.67 15.138 290.1 7.479 280.92 2.656 268.811 0 256 0s-24.921 2.656-34.1 7.479c-14.57 7.658-53.891 31.162-59.335 34.421a40.917 40.917 0 00-21.556 25.6 40.984 40.984 0 005.873 33.7l7.256 11.215c2.787 4.144 10.006 10 15 10h173.725c4.994 0 12.213-5.856 15-10l7.256-11.215a40.984 40.984 0 005.873-33.7z",
  fill: "#45c1f1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 321",
  d: "M370.992 67.5a40.911 40.911 0 00-21.555-25.6C344 38.644 304.67 15.138 290.1 7.479 280.92 2.656 268.811 0 256 0v122.415h86.863c4.994 0 12.213-5.856 15-10l7.256-11.215a40.986 40.986 0 005.873-33.7z",
  fill: "#44a4ec"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 322",
  d: "M352.525 155.941a15 15 0 00-12.215-3.308L256 167.193l-84.309-14.56a15 15 0 00-17.553 14.782v51.837a101.862 101.862 0 10203.724 0v-51.837a15 15 0 00-5.337-11.474z",
  fill: "#ffddc5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 323",
  d: "M352.525 155.941a15 15 0 00-12.215-3.308L256 167.193v153.92a101.978 101.978 0 00101.863-101.862v-51.837a15 15 0 00-5.338-11.473z",
  fill: "#ffc4a4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 324",
  d: "M256 132.415a15 15 0 01-15-15V75a15 15 0 1130 0v42.411a15 15 0 01-15 15z",
  fill: "#ffdc3c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 325",
  d: "M256 60.005v72.411a15 15 0 0015-15V75.005a15 15 0 00-15-15z",
  fill: "#ffb22d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 326",
  d: "M154.138 112.415v55a15 15 0 0012.447 14.785l86.861 15a14.991 14.991 0 005.106 0l86.863-15a15 15 0 0012.447-14.781v-55z",
  fill: "#505a6a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 327",
  d: "M256 112.415v85a14.994 14.994 0 002.553-.219l86.863-15a15 15 0 0012.447-14.781v-55z",
  fill: "#3d4757"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 328",
  d: "M265.441 386.5l-82.362-45.777-88.3 32.055c-21.349 7.755-38.073 31.621-38.073 54.334V497a15 15 0 0015 15H256a15 15 0 0015-15v-98.843a15 15 0 00-5.558-11.656z",
  fill: "#45c1f1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 329",
  d: "M417.215 372.778l-88.3-32.054L256 381.253V512h184.29a15 15 0 0015-15v-69.887c0-22.713-16.723-46.579-38.075-54.335z",
  fill: "#44a4ec"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 330",
  d: "M177.657 451.994h-30a15 15 0 010-30h30a15 15 0 110 30z",
  fill: "#f0f0f0"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 4",
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(333.149 421.999)",
  fill: "#cbdbf5"
}))));
export default SvgPoliceman;